// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomerSettings_container__3unof"};